import store from '@/store/index.js';
import { createRouter, createWebHistory } from 'vue-router'
import NotFound from '../views/NotFound.vue';
import News from '../views/news/index.vue';

// Define routes
const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/homeView/index.vue'),
        meta: {
            title: '首页 - 租号管家',
            description: '租号管家',
            keywords: '租号管家,管理平台,首页',
            requiresAuth: true
        }
    },
    {
        path: '/news/:id.html', 
        name: 'News', 
        component: News,
        meta: {
            title: '新闻详情_租号管家_Steam租号_帐号交易_买号_卖号_永久租号_帐号出租',
            description: '租号管家 - 新闻详情页，了解最新游戏资讯',
            keywords: '新闻详情,租号管家,游戏资讯'
        }
    },
    { 
        path: '/:pathMatch(.*)*', 
        name: 'NotFound', 
        component: NotFound,
        meta: {
            title: '页面未找到',
            description: '页面未找到',
            keywords: ',404,页面未找到'
        }
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

// Navigation guard - 统一权限验证逻辑
router.beforeEach(async (to, from, next) => {
    // Update document title
    document.title = to.meta.title || '租号管家';
    
    // 登录和找回密码页面不需要验证
    const noAuthRoutes = ['/login', '/404'];
    
    if (noAuthRoutes.includes(to.path)) {
        next();
        return;
    }
    
    // 如果权限模块未初始化，先获取权限
    // if (!store.getters['permission/isPermissionInitialized'] && !store.getters['permission/isPermissionLoading']) {
    //     try {
    //         await store.dispatch('permission/fetchPermissions');
    //     } catch (error) {
    //         console.error('获取权限失败:', error);
    //         // 权限获取失败时，允许访问基本页面
    //         next();
    //         return;
    //     }
    // }
    
    // // 检查是否有权限访问当前路径
    // try {
    //     const hasPermission = await store.dispatch('permission/checkPagePermission', to.path);
        
    //     if (!hasPermission) {
    //         // 如果没有权限，跳转到403页面
    //         next('/403');
    //         return;
    //     }
    // } catch (error) {
    //     console.error('检查页面权限失败:', error);
    //     // 权限检查失败时，允许访问
    //     next();
    //     return;
    // }
    
    next();
});

export default router;